import myDeliveryQuoteGql from "@/Apollo/query/product/myDeliveryQuote.graphql";
import {
  MyDeliveryQuoteQuery,
  MyDeliveryQuoteQueryVariables,
} from "@/Apollo/schema";
import { withDisplayCurrency } from "@/features/display-currency/display-currency.utils";
import { useDisplayCurrency } from "@/features/display-currency/useDisplayCurrency";
import { QueryHookOptions, useQuery } from "@apollo/client";

/** WHO-6509: the signed-in buyer's own US delivery quote on a listing (WHO-6499). */
export const useMyDeliveryQuote = (
  options: QueryHookOptions<MyDeliveryQuoteQuery, MyDeliveryQuoteQueryVariables>
) => {
  const currency = useDisplayCurrency();

  return useQuery(myDeliveryQuoteGql, withDisplayCurrency(options, currency));
};
